import React from 'react';

import { UISiteFooter } from '../../../components/uisite/footer';
import { UISiteHeaderMenu } from '../../../components/uisite/header/menu';

import { useForm, Controller } from 'react-hook-form';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';

import '../../../assets/style/pages/site/subpage/index.scss';

export const PageSigup = (props) => {


    const defaultValues = {
        name: '',
        email: '',
        phone:'',
        password:''
    }
    
    const form = useForm({ defaultValues });
    const control =  form.control;
    const errors  = form.formState.errors ;
    const handleSubmit = form.handleSubmit;

    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error">{errors[name].message}</small>
    };

    const onSubmit = (_data) =>{
        //setIsLoad(true);
    }

    return (
        <div className="page-signup">
            <header>
                <UISiteHeaderMenu {...props} />
            </header>
            <section>
                <div className="content">
                    <h1>
                        Cadastro de usuário
                    </h1>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="p-grid p-mt-2 p-mb-2">
                            <div className="p-col-12 p-md-6">
                                <div className="p-field">
                                    <span className="p-float-label">
                                        <Controller name="name" control={control} rules={{ required: 'Campo obrigatório', maxLength:11, minLength:11 }} render={({ field, fieldState }) => (
                                            <InputText type="text" style={{width:'100%'}} id={field.name} {...field} />
                                        )} />
                                        <label htmlFor="name">Nome *</label>
                                    </span>
                                    {getFormErrorMessage('name')}
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="p-field">
                                    <span className="p-float-label">
                                        <Controller name="email" control={control} rules={{ required: 'Campo obrigatório', maxLength:11, minLength:11 }} render={({ field, fieldState }) => (
                                            <InputText type="email" style={{width:'100%'}} id={field.name} {...field} />
                                        )} />
                                        <label htmlFor="email">Email *</label>
                                    </span>
                                    {getFormErrorMessage('email')}
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="p-field">
                                    <span className="p-float-label">
                                        <Controller name="phone" control={control} rules={{ required: 'Campo obrigatório', maxLength:11, minLength:11 }} render={({ field, fieldState }) => (
                                            <InputText type="tel" style={{width:'100%'}} id={field.name} {...field} />
                                        )} />
                                        <label htmlFor="phone">Telefone *</label>
                                    </span>
                                    {getFormErrorMessage('phone')}
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="p-field">
                                    <span className="p-float-label">
                                        <Controller name="password" control={control} rules={{ required: 'Campo obrigatório', maxLength:11, minLength:11 }} render={({ field, fieldState }) => (
                                            <Password feedback={false} inputStyle={{width:'100%'}} style={{width:'100%'}} id={field.name} {...field} />
                                        )} />
                                        <label htmlFor="password">Senha *</label>
                                    </span>
                                    {getFormErrorMessage('password')}
                                </div>
                            </div>
                            <div style={{textAlign:'center'}} className="p-col-12">
                                <Button type="submit" style={{margin:'0 auto'}} label="Cadastrar" />
                            </div>
                        </div>
                    </form>
                </div>
            </section>
            <footer>
                <UISiteFooter {...props} />
            </footer>
        </div>
    )
}